import Vue from 'vue'

const state = () => ({
    data: null
})

const getters = {
}

const actions = {
}

const mutations = {
    setConfig(state, data) {
        state.data = data
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}